import { get } from "sites-common/utils/lodash";

export const appSelector = (state) => state.app;

export const selectorBehaveAs = (state) =>
  get(appSelector(state), "behaveAs", "");
